import { GridValidRowModel, DataGridPro } from '@mui/x-data-grid-pro';
import { useMemo } from 'react';
import type { SxProps, Theme } from '@mui/material';

import type { RosterDataGridProps } from './types';
import { dataGridStyles } from './RosterDataGrid.styles';
import { useRosterDataGrid } from './hooks/useRosterDataGrid';

export default function RosterDataGrid<
  R extends GridValidRowModel = GridValidRowModel,
  V extends string = never
>({
  rosterDays,
  rows,
  fixedColumnsLeft = [],
  fixedColumnsRight = [],
  timelineView = 'weeksOnly',
  pinnedColumns,
  renderTimelineCell,
  sx,
  rowHeight,
  timelineColumnWidth,
  timelineRelativeStartDate,
  stretchTimelineColumns,
  getRowClassName,
  customViewBuilders
}: RosterDataGridProps<R, V>) {
  const { columns, columnGroupingModel } = useRosterDataGrid<R, V>({
    rosterDays,
    timelineView,
    fixedColumnsLeft,
    fixedColumnsRight,
    renderTimelineCell,
    timelineColumnWidth,
    timelineRelativeStartDate,
    stretchTimelineColumns,
    customViewBuilders
  });

  const mergedSx = useMemo(
    () => (sx ? [dataGridStyles, sx] : dataGridStyles) as SxProps<Theme>,
    [sx]
  );

  return (
    <DataGridPro<R>
      rows={rows}
      columns={columns}
      columnGroupingModel={columnGroupingModel}
      pinnedColumns={pinnedColumns}
      disableRowSelectionOnClick
      hideFooter
      rowHeight={rowHeight}
      pinnedColumnsSectionSeparator="border-and-shadow"
      getRowClassName={getRowClassName}
      sx={mergedSx}
    />
  );
}
